import { createAction, props } from '@ngrx/store';

import {
  IdentityVerificationSettings,
} from '../../models/identity-verification-response';

export const GetIdentityFlow = createAction('[Identity] Get flow');
export const GetIdentityFlowSuccess = createAction(
  '[Identity] Get flow success',
  props<{ settings: IdentityVerificationSettings }>()
);
export const GetIdentityFlowFail = createAction('[Identity] Get flow fail');
export const GetRequest = createAction('[Identity] Get request');
export const GetRequestSuccess = createAction(
  '[Identity] Get request success',
  props<{ rejectReason: string }>(),
);
export const GetRequestFail = createAction('[Identity] Get request fail');
